
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import TabBar from '../../components/layout/TabBar';

export default function Profile() {
  const navigate = useNavigate();
  const [darkMode, setDarkMode] = useState(false);
  const isGuest = localStorage.getItem('isGuest') === 'true';

  const handleLogout = () => {
    localStorage.removeItem('isGuest');
    navigate('/login');
  };

  return (
    <div className="min-h-screen bg-[#F6F6F6] pb-20">
      {/* Header */}
      <div className="bg-gradient-to-br from-[#1565C0] to-[#2E7D32] pt-12 pb-8 px-6 rounded-b-[30px]">
        <div className="flex flex-col items-center animate-fadeIn">
          <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center mb-3 shadow-lg">
            <i className="ri-user-line text-[#1565C0] text-3xl"></i>
          </div>
          <h2 className="text-xl font-bold text-white mb-1">
            {isGuest ? 'زائر' : 'أحمد محمد'}
          </h2>
          <p className="text-white/80 text-sm">
            {isGuest ? 'وضع الزائر 🎭' : '+966 50 123 4567'}
          </p>
        </div>
      </div>

      {/* Profile Options */}
      <div className="px-6 mt-6">
        {/* Wallet */}
        <div className="bg-white rounded-2xl overflow-hidden shadow-md mb-4 animate-slideUp">
          <button
            onClick={() => navigate('/wallet')}
            className="w-full flex items-center gap-3 p-4 hover:bg-gray-50 transition-all"
          >
            <div className="w-10 h-10 bg-[#FBC02D]/10 rounded-xl flex items-center justify-center">
              <i className="ri-wallet-3-line text-[#FBC02D] text-lg"></i>
            </div>
            <div className="flex-1 text-right">
              <span className="block font-semibold text-[#212121]">المحفظة</span>
              <span className="text-xs text-gray-500">الرصيد: 450 ر.س</span>
            </div>
            <i className="ri-arrow-left-s-line text-gray-400"></i>
          </button>
        </div>

        {/* Personal Info */}
        <div className="bg-white rounded-2xl overflow-hidden shadow-md mb-4 animate-slideUp stagger-1">
          <button
            onClick={() => !isGuest && navigate('/personal-info')}
            className={`w-full flex items-center gap-3 p-4 ${isGuest ? 'opacity-50' : 'hover:bg-gray-50'} transition-all`}
            disabled={isGuest}
          >
            <div className="w-10 h-10 bg-[#1565C0]/10 rounded-xl flex items-center justify-center">
              <i className="ri-user-3-line text-[#1565C0] text-lg"></i>
            </div>
            <span className="flex-1 text-right font-semibold text-[#212121]">البيانات الشخصية</span>
            <i className="ri-arrow-left-s-line text-gray-400"></i>
          </button>
        </div>

        {/* Addresses */}
        <div className="bg-white rounded-2xl overflow-hidden shadow-md mb-4 animate-slideUp stagger-2">
          <button
            onClick={() => !isGuest && navigate('/addresses')}
            className={`w-full flex items-center gap-3 p-4 ${isGuest ? 'opacity-50' : 'hover:bg-gray-50'} transition-all`}
            disabled={isGuest}
          >
            <div className="w-10 h-10 bg-[#2E7D32]/10 rounded-xl flex items-center justify-center">
              <i className="ri-map-pin-line text-[#2E7D32] text-lg"></i>
            </div>
            <span className="flex-1 text-right font-semibold text-[#212121]">العناوين المحفوظة</span>
            <i className="ri-arrow-left-s-line text-gray-400"></i>
          </button>
        </div>

        {/* Payment Methods */}
        <div className="bg-white rounded-2xl overflow-hidden shadow-md mb-4 animate-slideUp stagger-3">
          <button
            onClick={() => !isGuest && navigate('/payment-methods')}
            className={`w-full flex items-center gap-3 p-4 ${isGuest ? 'opacity-50' : 'hover:bg-gray-50'} transition-all`}
            disabled={isGuest}
          >
            <div className="w-10 h-10 bg-[#F57C00]/10 rounded-xl flex items-center justify-center">
              <i className="ri-bank-card-line text-[#F57C00] text-lg"></i>
            </div>
            <span className="flex-1 text-right font-semibold text-[#212121]">طرق الدفع</span>
            <i className="ri-arrow-left-s-line text-gray-400"></i>
          </button>
        </div>

        {/* Dark Mode */}
        <div className="bg-white rounded-2xl overflow-hidden shadow-md mb-4 animate-slideUp stagger-4">
          <div className="flex items-center gap-3 p-4">
            <div className="w-10 h-10 bg-[#6A1B9A]/10 rounded-xl flex items-center justify-center">
              <i className="ri-moon-line text-[#6A1B9A] text-lg"></i>
            </div>
            <span className="flex-1 text-right font-semibold text-[#212121]">الوضع الداكن</span>
            <button
              onClick={() => setDarkMode(!darkMode)}
              className={`relative w-12 h-6 rounded-full transition-all ${
                darkMode ? 'bg-[#1565C0]' : 'bg-gray-300'
              }`}
            >
              <div
                className={`absolute top-0.5 w-5 h-5 bg-white rounded-full transition-all ${
                  darkMode ? 'left-0.5' : 'right-0.5'
                }`}
              ></div>
            </button>
          </div>
        </div>

        {/* Support */}
        <div className="bg-white rounded-2xl overflow-hidden shadow-md mb-4 animate-slideUp stagger-5">
          <button className="w-full flex items-center gap-3 p-4 hover:bg-gray-50 transition-all">
            <div className="w-10 h-10 bg-[#00838F]/10 rounded-xl flex items-center justify-center">
              <i className="ri-customer-service-2-line text-[#00838F] text-lg"></i>
            </div>
            <span className="flex-1 text-right font-semibold text-[#212121]">الدعم الفني</span>
            <i className="ri-arrow-left-s-line text-gray-400"></i>
          </button>
        </div>

        {/* About */}
        <div className="bg-white rounded-2xl overflow-hidden shadow-md mb-4 animate-slideUp stagger-6">
          <button className="w-full flex items-center gap-3 p-4 hover:bg-gray-50 transition-all">
            <div className="w-10 h-10 bg-[#0277BD]/10 rounded-xl flex items-center justify-center">
              <i className="ri-information-line text-[#0277BD] text-lg"></i>
            </div>
            <span className="flex-1 text-right font-semibold text-[#212121]">عن التطبيق</span>
            <i className="ri-arrow-left-s-line text-gray-400"></i>
          </button>
        </div>

        {/* Logout */}
        <div className="bg-white rounded-2xl overflow-hidden shadow-md animate-slideUp stagger-7">
          <button
            onClick={handleLogout}
            className="w-full flex items-center gap-3 p-4 hover:bg-red-50 transition-all"
          >
            <div className="w-10 h-10 bg-red-500/10 rounded-xl flex items-center justify-center">
              <i className="ri-logout-box-line text-red-500 text-lg"></i>
            </div>
            <span className="flex-1 text-right font-semibold text-red-500">
              {isGuest ? 'الخروج من وضع الزائر' : 'تسجيل الخروج'}
            </span>
          </button>
        </div>

        {/* Version */}
        <div className="text-center mt-6 pb-4">
          <p className="text-xs text-gray-400">الإصدار 1.0.0</p>
        </div>
      </div>

      <TabBar />
    </div>
  );
}
